import { MaskPhone } from '@js/components/form/plugins/mask-phone';

document.addEventListener('DOMContentLoaded', () => {
    const jscheckall = document.querySelectorAll('.js-check-all');
    const jscheckallText = document.querySelector('.js-check-all-text');
    jscheckall.forEach((item, index) => {
        const inputs = item.querySelectorAll('input[type="checkbox"]');
        const inputAll = item.querySelector('input[data-check="all"]');
        inputs.forEach((input) => {
            input.addEventListener('change',(e)=>{
               if(input.getAttribute('data-check')){
                   if(input.checked){
                       inputs.forEach((inp) => {
                           if(!inp.getAttribute('data-check')) {
                               inp.checked = false;
                           }
                       });
                   }
               }
               else{
                   if(input.checked){
                       inputAll.checked = false;
                   }
               }
               let text = '';
                inputs.forEach((inp,i) => {
                    if(inp.checked){
                        text = text + inp.getAttribute('data-text')+', ';
                    }
                });
                text = text.substring(0, text.length - 2);
                if (typeof jscheckallText !== 'undefined' && jscheckallText !== null) {
                    jscheckallText.textContent = text;
                }
            });
        });
    });

});
